/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/blog-slider.js":
/*!*******************************!*\
  !*** ./src/js/blog-slider.js ***!
  \*******************************/
/***/ (() => {

$(document).ready(function () {
  var blog_slider = document.querySelector('.blog-slider');
  if (!blog_slider) return;
  if (blog_slider) {
    var desktop_number = blog_slider.getAttribute('data-per-row');
    var tablet_number = blog_slider.getAttribute('data-per-row-tablet');
    var mobile_number = blog_slider.getAttribute('data-per-row-mobile');
    $('.slick-blog').slick({
      dots: false,
      arrows: true,
      nextArrow: '<button class="btn-next"><i class="theme-iconnext"></i></button>',
      prevArrow: '<button class="btn-prev"><i class="theme-iconback"></i></button>',
      speed: 300,
      rows: 1,
      centerPadding: '0',
      centerMode: true,
      slidesToShow: desktop_number,
      autoplay: true,
      responsive: [{
        breakpoint: 980,
        // tablet breakpoint
        settings: {
          slidesToShow: tablet_number,
          slidesToScroll: 1
        }
      }, {
        breakpoint: 480,
        // mobile breakpoint
        settings: {
          slidesToShow: mobile_number,
          slidesToScroll: 1
        }
      }]
    });
  }
});

/***/ }),

/***/ "./src/js/cart-ajax.js":
/*!*****************************!*\
  !*** ./src/js/cart-ajax.js ***!
  \*****************************/
/***/ (() => {

var x = setInterval(function () {
  var tcaTtem = document.querySelectorAll(".tca-icon__item");
  for (var i = 0; i <= tcaTtem.length - 1; i++) {
    if (tcaTtem[i].hasAttribute("data-show")) {
      tcaTtem[i].addEventListener("click", tcaClick);
    }
  }
  function tcaClick(e) {
    var dataClick = this.getAttribute("data-show");
    var tcaContent = document.querySelectorAll(".tca_item");
    for (var _i = 0; _i <= tcaContent.length - 1; _i++) {
      tcaContent[_i].classList.add("ajc-hidden");
    }
    if (dataClick === "note") {
      document.querySelector(".tca__note").classList.remove("ajc-hidden");
    } else if (dataClick === "coupon") {
      document.querySelector(".tca_coupon").classList.remove("ajc-hidden");
    } else if (dataClick === "shipping") {
      document.querySelector(".tca_shipping").classList.remove("ajc-hidden");
    } else {
      document.querySelector(".tca_gift_wrap").classList.remove("ajc-hidden");
    }
  }
  document.addEventListener("click", function (e) {
    if (e.target.classList.contains("stp-tool__back")) {
      e.target.closest(".tca_item").classList.add("ajc-hidden");
    }
  });
}, 1000);
var ajc_discount__push = document.querySelector(".ajc-discount__push");
if (ajc_discount__push) {
  ajc_discount__push.addEventListener("click", function () {
    var codeInput = document.querySelector("#CartDiscountcode");
    if (codeInput.value !== null && codeInput.value !== "") {
      window.localStorage.setItem("discountCode", codeInput.value);
      var url = window.location.href + "discount/" + codeInput.value;
      fetch(url).then(function (response) {
        console.log('discount code applied');
      }).then(function (data) {
        return data;
      });
    }
    this.closest(".tca_coupon").classList.add("ajc-hidden");
  });
}
var discountCode = localStorage.getItem("discountCode");
if (discountCode != null && discountCode !== "") {
  var codeInput = document.querySelectorAll(".CartDiscountcode");
  codeInput.forEach(function (input) {
    input.value = discountCode;
    input.textContent = discountCode;
  });
}
if (document.querySelector("#cpcode-incart__apply")) {
  document.querySelector("#cpcode-incart__apply").addEventListener("click", function () {
    var codeInput = document.querySelector("input[name='cartdiscountcode']");
    if (codeInput.value !== null && codeInput.value !== "") {
      window.localStorage.setItem("discountCode", codeInput.value);
      var this_url = window.location.href;
      var finish_url = this_url.replace("/cart", "");
      var url = finish_url + "/discount/" + codeInput.value;
      document.querySelector(".load-more_spinner").classList.remove("hide");
      document.querySelector(".load-more_text").classList.add("hide");
      fetch(url).then(function (response) {
        document.querySelector(".load-more_spinner").classList.add("hide");
        document.querySelector(".load-more_text").classList.remove("hide");
        document.querySelector(".cp-applied").classList.remove("hide");
      })["catch"](function (err) {
        console.log(err);
      });
    }
  });
  document.querySelector(".cp-applied__close").addEventListener("click", function () {
    this.closest(".cp-applied").classList.add("hide");
  });
}

// Click save cart note
var saveCartNote = document.querySelector(".save-cart-note");
if (saveCartNote) {
  saveCartNote.addEventListener("click", function (e) {
    e.preventDefault();
    var cartNote = document.querySelector(".tca__note");
    if (cartNote) {
      cartNote.classList.add("ajc-hidden");
    }
  });
}

// Render free shipping
var freeShipping = document.querySelector(".tca-footer__freeship");
if (freeShipping) {
  var freeShippingfscode = freeShipping.querySelector('.process-bar__data').getAttribute('data-fscode');
  var freeShippingCompare = freeShipping.querySelector('.process-bar__data').getAttribute('data-compare');
  if (freeShippingCompare == "true") {
    if (freeShippingfscode !== null && freeShippingfscode !== "") {
      var url = window.location.href + "discount/" + freeShippingfscode;
      console.log(url);
      fetch(url).then(function (lineitem) {
        console.log('discount code applied');
      }).then(function (data) {
        return data;
      });
    }
  }
}

/***/ }),

/***/ "./src/js/theme.js":
/*!*************************!*\
  !*** ./src/js/theme.js ***!
  \*************************/
/***/ (() => {

if ($(window).width() > 1024) {
  var slick_slide = $('.blog-slider.blog-style-featured .slick-slide');
  for (var i = 0; i < slick_slide.length; i++) {
    var href = $(slick_slide[i]).hasClass('slick-current');
    if (!href) {
      $(slick_slide[i]).addClass('col-right-blog');
    }
  }
  setInterval(function () {
    var height_blog_left = $('.blog-slider.blog-style-featured .slick-slide.slick-current.slick-active').height();
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right ').css('height', height_blog_left - 30);
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right .post-image ').css('height', height_blog_left - 30);
  }, 100);
  $(window).resize(function () {
    var height_blog_left = $('.blog-slider.blog-style-featured .slick-slide.slick-current.slick-active').height();
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right').css('height', height_blog_left - 30);
    $('.blog-slider.blog-style-featured .slick-slide.col-right-blog.slick-active .col-right .post-image ').css('height', height_blog_left - 30);
  });
}

//fix load image product slider
window.addEventListener('DOMContentLoaded', function () {
  var grid_slider = document.querySelector('.loading-slider');
  if (grid_slider) {
    var items = grid_slider.querySelectorAll('.item');
    if (grid_slider) {
      if (items.length > 0) {
        items.forEach(function (item) {
          item.classList.remove('hidden');
        });
      }
      grid_slider.style.maxHeight = grid_slider.scrollHeight + 'px';
    }
  }
  ;
});
var popupNewletter = document.querySelector('#shopify-section-gp-popup-newsletter');
if (popupNewletter) {
  var getCookie = function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var _i = 0; _i < ca.length; _i++) {
      var c = ca[_i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  };
  var setCookie = function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  };
  var popup_newletter = getCookie("popup_newletter");
  if (popup_newletter == 'closed') {
    popupNewletter.remove();
  }
  var buttonClose = popupNewletter.querySelector('#close-popup');
  buttonClose.addEventListener('click', function () {
    popupNewletter.remove();
    setCookie("popup_newletter", 'closed', 1);
  });
}
$(document).ready(function () {
  var gp_lookbook = document.querySelector('.gp-lookbook-slider-js');
  if (!gp_lookbook) return;
  var data_arrow = gp_lookbook.getAttribute('data-slideshow-arrow');
  var arrows = false;
  if (data_arrow == 'true') {
    arrows = true;
  }
  $('.gp-lookbook-slider-js').slick({
    dots: false,
    arrows: arrows,
    // autoplay: true,
    // speed: 300,
    nextArrow: '<button class="btn-next"><i class="theme-iconnext"></i></button>',
    prevArrow: '<button class="btn-prev"><i class="theme-iconback"></i></button>'
  });
});
$(document).ready(function () {
  $(document).on('click', '.gp-lookbook-slider .lookbook-item .pin-wrapper', function () {
    var id = $(this).data('block-id');
    $('.gp-lookbook-slider .lookbook-item .pin-product-image').removeClass('active');
    $('.gp-lookbook-slider .lookbook-item .pin-wrapper').removeClass('active');
    if ($('.gp-lookbook-slider .lookbook-item .pin-product-image').length) {
      $('.gp-lookbook-slider .lookbook-item .pin-product-image').each(function () {
        var block_product_id = $(this).data('block-id');
        if (block_product_id == id) {
          $(this).addClass('active');
        }
      });
    }
  });
  // click outsite close lookbook
  $(document).on('click', function (e) {
    var container_lookbook = $('.gp-lookbook-slider .lookbook-item .pin-wrapper');
    var container_lookbook2 = $('.gp-lookbook-slider .lookbook-item .pin-product-image');
    if (!container_lookbook.is(e.target) && container_lookbook.has(e.target).length === 0 && !container_lookbook2.is(e.target) && container_lookbook2.has(e.target).length === 0) {
      $('.gp-lookbook-slider .lookbook-item .pin-product-image').removeClass('active');
      $('.gp-lookbook-slider .lookbook-item .pin-wrapper').removeClass('active');
    }
  });
});
var TpLazyloadImg = function () {
  return {
    init: function init() {
      this.lazyReady();
    },
    lazyReady: function lazyReady() {
      if (!!window.IntersectionObserver) {
        var observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.width = entry.boundingClientRect.width;
              entry.target.height = entry.boundingClientRect.height;
              entry.target.sizes = "".concat(entry.boundingClientRect.width, "px");
              entry.target.classList.add("tp-loaded-image");
              entry.target.closest(".tp-image-js").classList.remove("tp-loading-image");
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: "10px"
        });
        document.querySelectorAll(".tp-image-js img").forEach(function (img) {
          observer.observe(img);
        });
      }
    }
  };
}();
TpLazyloadImg.init();

/***/ }),

/***/ "./src/sass/main.scss":
/*!****************************!*\
  !*** ./src/sass/main.scss ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/chunk loaded */
/******/ 	(() => {
/******/ 		var deferred = [];
/******/ 		__webpack_require__.O = (result, chunkIds, fn, priority) => {
/******/ 			if(chunkIds) {
/******/ 				priority = priority || 0;
/******/ 				for(var i = deferred.length; i > 0 && deferred[i - 1][2] > priority; i--) deferred[i] = deferred[i - 1];
/******/ 				deferred[i] = [chunkIds, fn, priority];
/******/ 				return;
/******/ 			}
/******/ 			var notFulfilled = Infinity;
/******/ 			for (var i = 0; i < deferred.length; i++) {
/******/ 				var [chunkIds, fn, priority] = deferred[i];
/******/ 				var fulfilled = true;
/******/ 				for (var j = 0; j < chunkIds.length; j++) {
/******/ 					if ((priority & 1 === 0 || notFulfilled >= priority) && Object.keys(__webpack_require__.O).every((key) => (__webpack_require__.O[key](chunkIds[j])))) {
/******/ 						chunkIds.splice(j--, 1);
/******/ 					} else {
/******/ 						fulfilled = false;
/******/ 						if(priority < notFulfilled) notFulfilled = priority;
/******/ 					}
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferred.splice(i--, 1)
/******/ 					var r = fn();
/******/ 					if (r !== undefined) result = r;
/******/ 				}
/******/ 			}
/******/ 			return result;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"/assets/theme": 0,
/******/ 			"assets/main.min": 0
/******/ 		};
/******/ 		
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		__webpack_require__.O.j = (chunkId) => (installedChunks[chunkId] === 0);
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some((id) => (installedChunks[id] !== 0))) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			return __webpack_require__.O(result);
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = self["webpackChunkshopify_lusion"] = self["webpackChunkshopify_lusion"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module depends on other loaded chunks and execution need to be delayed
/******/ 	__webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/js/blog-slider.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/js/cart-ajax.js")))
/******/ 	__webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/js/theme.js")))
/******/ 	var __webpack_exports__ = __webpack_require__.O(undefined, ["assets/main.min"], () => (__webpack_require__("./src/sass/main.scss")))
/******/ 	__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
/******/ 	
/******/ })()
;